import { createReducer } from '@reduxjs/toolkit';

import { CIVILITY } from 'constants/Global';
import { FETCH_ENTITY_SUCCESS } from 'modules/entity/actionTypes';

import * as actionTypes from '../../actionTypes';

/**
 * @typedef {boolean} VatCheckedState
 */

/** @type {VatCheckedState} */
const initialState = true;

/**
 * @param {VatCheckedState} _
 * @param {import('modules/entity/types').FetchEntitySuccessAction} action
 * @returns {VatCheckedState}
 */
const init = (_, { payload: entity }) => {
  const customerInfo = entity.intervention?.customerInfo ?? entity.customerInfo;
  return customerInfo?.civility !== CIVILITY.COMPANY;
};

/**
 * @param {VatCheckedState} state
 * @returns {VatCheckedState}
 */
const toggle = (state) => !state;

export default createReducer(initialState, (builder) => {
  builder.addCase(FETCH_ENTITY_SUCCESS, init);
  builder.addCase(actionTypes.TOGGLE_VAT, toggle);
});
